<template>
  <v-row>
    <v-col cols="12">
      <v-divider v-if="rotulo"></v-divider>
      <label v-if="rotulo">{{ rotulo }}</label>
      <v-input filled rounded dense color="primary">
        <div v-if="lista && lista.length">
          <div v-for="item of lista" :key="item">• {{ item }}</div>
          <div v-if="complemento">{{ complementoRotulo }}: {{ complemento }}</div>
        </div>
        <div v-else-if="complemento">{{ complementoRotulo }}: {{ complemento }}</div>
        <div v-else style="white-space: pre-wrap">{{ texto || "- - -" }}</div>
      </v-input>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "ECampoVisualizacaoAEE",
  props: {
    rotulo: {
      type: String,
      default: null,
    },
    texto: {
      type: String,
      default: null,
    },
    /** Campos de múltipla seleção do PAEE chegam como array de strings. */
    lista: {
      type: Array,
      default: null,
    },
    complemento: {
      type: String,
      default: null,
    },
    complementoRotulo: {
      type: String,
      default: "Outros",
    },
  },
};
</script>
